<kendo-dialog-titlebar>
    {{'shared.header.setValue' | translate}}
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">

    <form [formGroup]="form">
         <checkbox-input-ctrl [settings]="{fxFill:true}" [caption]="caption | translate"
            [formControlName]="'checkedValue'" >
         </checkbox-input-ctrl>

    </form>
    
    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.confirm' | translate}}</span>
        </button>
    </div>
</div>